import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerSelectLocationDialogResourceBundleEn(
  i18next: i18n
): void {
  i18next.addResourceBundle(
    'en',
    'record-it-components',
    {
      location: {
        SelectLocationDialog: {
          cancel: 'cancel',
          latitude: 'latitude',
          longitude: 'longitude',
          title: 'select coordinates'
        }
      }
    } as Partial<CustomTypeOptions['resources']['record-it-components']>,
    true
  );
}
